import { Entitlements } from '@experiences/constants';
import React, { useMemo } from 'react';
import { Outlet } from 'react-router';

import { useBreadcrumbs } from '../../common/providers/BreadcrumbProvider';
import { UiResizablePageContainer } from '../common/UiPageContainer/UiResizablePageContainer';
import AdminBreadCrumbs from '../organizationsettings/AdminBreadCrumbs';
import { UpgradeGuard } from '../upgrade/UpgradeGuard';
import { ConsentList } from './ConsentList';
import { useConsentList } from './ConsentListViewModel';
import { ConsentUserRecords } from './ConsentUserRecords';
import { NoConsents } from './NoConsents';

const OrgConsentPageComponent: React.FC = () => {
    const { breadcrumbs } = useBreadcrumbs();

    const {
        consents, isLoading, consentIdSearchParam,
    } = useConsentList();

    const renderedContent = useMemo(() => <UpgradeGuard requiredEntitlement={Entitlements.UserConsent}>
        <>
            {consents && consents.length === 0 && <NoConsents />}
            {consents && consents.length > 0 && <ConsentList />}
        </>
    </UpgradeGuard>, [ consents ]);

    return (
        <UiResizablePageContainer
            breadcrumb={<AdminBreadCrumbs breadCrumbTrail={breadcrumbs} />}
            drawer={<ConsentUserRecords recurrenceInDays={consents?.find(c => c.id === consentIdSearchParam)?.recurrenceInDays} />}
            showDrawer={!!consentIdSearchParam}
            loading={isLoading}
        >
            {renderedContent}
        </UiResizablePageContainer>
    );
};

export default () => (
    <>
        <OrgConsentPageComponent />
        <Outlet />
    </>
);
